export const environment = {
  production: false,
  api: 'https://cmsdev.tpllabs.ca/api',
  sentryDsn: 'https://4e0f073194cc2e1d6c0cf652052fd9c1@o4511546999177216.ingest.de.sentry.io/4512221282828368',
};
